import { createTheme } from "@mui/material";

const theme = createTheme({
  colorSchemes: {
    dark: {
      palette: {
        primary: {
          main: "#9293ED",
        },
        background: {
          default: "#000F08",
        },
        text: {
          primary: "#F4FFF8",
        },
      },
    },
    light: {
      palette: {
        primary: {
          main: "#454ADE",
        },
        background: {
          default: "#F4FFF8",
        },
        text: {
          primary: "#000F08",
        },
      },
    },
  },
  typography: {
    fontFamily: "Kode Mono, monospace",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: "none",
          borderRadius: "16px",
        }),
        outlined: ({ theme }) => ({
          border: `3px solid ${theme.palette.primary.main} `,
          fontWeight: "bold",
          "&.Mui-disabled": {
            color: `${theme.palette.text.primary}88`,
            backgroundColor: `${theme.palette.primary.main}33`,
          },
        }),
      },
    },
    MuiLink: {
      defaultProps: {
        target: "_blank",
        rel: "noopener noreferrer",
      },
      styleOverrides: {
        root: {
          fontWeight: "bold",
          textDecoration: "none",
          transition: "text-decoration 0.8s",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        }),
      },
    },
  },
});

export default theme;
